import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { TikTokLoginButton } from "react-social-login-buttons";
import { baseURL } from "../../shared/env";

function TikTok() {
    const [authorized, setAuthorized] = useState(false);
    const { setValue } = useFormContext();

    const handleTikTokLogin = () => {
        const params = new URLSearchParams({
          app_id: "7540554693329174529",
          redirect_uri: `${baseURL}/`,
        });

        const popup = window.open(
            `https://business-api.tiktok.com/portal/auth?${params.toString()}`,
            "tiktokLogin",
            "width=600,height=700"
        );

        const interval = setInterval(() => {
            try {
                if (!popup || popup.closed) {
                    clearInterval(interval);
                    return;
                }

                const popupUrl = new URL(popup.location.href);
                const code = popupUrl.searchParams.get("code");

                if (code) {
                    setValue("token", code);
                    setAuthorized(true);
                    popup.close();
                    clearInterval(interval);
                }
            } catch (err) {
                // Cross-origin errors until redirect happens
            }
        }, 500);
    };

    return (
        <div>
            {!authorized ? (
                <div>
                    <div className="create-destination__platform-header">
                        Authorize your TikTok connection:
                    </div>
                    <TikTokLoginButton onClick={handleTikTokLogin} />
                </div>
            ) : (
                <div>
                    <div className="create-destination__platform-header">
                        Your TikTok authorization code has been obtained
                    </div>
                </div>
            )}
        </div>
    );
}

export default TikTok;